import './PageLoader.scss'

const PageLoader = ({ message = 'Loading…' }) => (
  <div className="page-loader">
    <div className="page-loader__card">
      <div className="page-loader__logo">
        {/* Inline the small logo SVG so it works without import resolution */}
        <svg width="40" height="40" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 9.69C0 4.34 4.34 0 9.69 0h25.09c5.35 0 9.69 4.34 9.69 9.69v26.23c0 5.35-4.34 9.69-9.69 9.69H9.69C4.34 45.61 0 41.27 0 35.92V9.69z" fill="white"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M34.78.76H9.69C4.76.76.76 4.76.76 9.69v26.23c0 4.93 4 8.93 8.93 8.93h25.09c4.93 0 8.93-4 8.93-8.93V9.69C43.71 4.76 39.71.76 34.78.76zM9.69 0C4.34 0 0 4.34 0 9.69v26.23c0 5.35 4.34 9.69 9.69 9.69h25.09c5.35 0 9.69-4.34 9.69-9.69V9.69C44.47 4.34 40.13 0 34.78 0H9.69z" fill="#45ABE1"/>
          <path d="M18.43 7.98h1.33c3.46 0 6.27 2.81 6.27 6.27v23.38h-1.33c-3.46 0-6.27-2.81-6.27-6.27V7.98z" fill="#45ABE1" className="bar bar-1"/>
          <path d="M28.89 16.34h1.33c3.46 0 6.27 2.81 6.27 6.27v15.02h-1.33c-3.46 0-6.27-2.81-6.27-6.27V16.34z" fill="#37D4AD" className="bar bar-2"/>
          <path d="M28.89 7.98h1.33c3.46 0 6.27 2.81 6.27 6.27v.76h-1.33c-3.46 0-6.27-2.81-6.27-6.27V7.98z" fill="#D7B05B" className="bar bar-3"/>
          <path d="M7.98 37.63h1.33c3.46 0 6.27-2.81 6.27-6.27V14.44H14.25c-3.46 0-6.27 2.81-6.27 6.27v16.92z" fill="#89CFF4" className="bar bar-4"/>
        </svg>
      </div>
      <div className="page-loader__bars">
        <span/><span/><span/>
      </div>
      <p className="page-loader__msg">{message}</p>
    </div>
  </div>
)

export default PageLoader